import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface ShippingAddressOptionSelectedState {
    isSelected: boolean;
}

const initialState: ShippingAddressOptionSelectedState = {
    isSelected: false,
};

const reducer = {
    "Custom/CheckoutShipping/SetShippingAddressOptionSelected": (
        draft: Draft<ShippingAddressOptionSelectedState>,
        action: { isSelected: boolean },
    ) => {
        draft.isSelected = action.isSelected;
    },
    // Each entry to the CheckoutShipping page (refresh or nav from cart) starts with no option preselected.
    "Pages/CheckoutShipping/SetCartId": (draft: Draft<ShippingAddressOptionSelectedState>) => {
        draft.isSelected = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
